import { GET_PLANS, ADD_PLAN, UPDATE_PLAN, DELETE_PLAN } from '../actions/Plan.action';

const initialState = {
    getPlans: '',
    addPlan: '',
    updatePlan: '',
    deletePlan: ''
}

const PlanReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PLANS:
            return { ...state, getPlans: action.payload }
        case ADD_PLAN:
            return { ...state, addPlan: action.payload }
        case UPDATE_PLAN:
            return { ...state, updatePlan: action.payload }
        case DELETE_PLAN:
            return { ...state, deletePlan: action.payload }
        default:
            return { ...state }
    }
}

export default PlanReducer